import {
  VIEWER_REPORT_NOMDAY_MODEL_LIST,
  VIEWER_REPORT_NOMDAY_SEARCH,
  VIEWER_REPORT_NOMDAY_PAGINATION,
  VIEWER_REPORT_NOMDAY_DROP_DOWN_SEARCH_TYPE,
} from "./actionType";

import moment from 'moment';

const initialState = {
  modelDeviceList: [],
  modelSearch: { UPLOAD_START: "", UPLOAD_TO: "", UPLOADTYPE_NAME: null, STATUS_FLAG: 1 },
  dropDownSearchType: null,
  pagination: { sizePerPage: 100, page: 1 }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case VIEWER_REPORT_NOMDAY_MODEL_LIST:
      return { ...state, modelDeviceList: action.payload };
    case VIEWER_REPORT_NOMDAY_SEARCH:
      return {
        ...state,
        modelSearch: action.payload,
      };
    case VIEWER_REPORT_NOMDAY_PAGINATION:
      return { ...state, pagination: { sizePerPage: action.payload.sizePerPage, page: action.payload.page } };
    case VIEWER_REPORT_NOMDAY_DROP_DOWN_SEARCH_TYPE:
      return {
        ...state,
        dropDownSearchType: action.payload,
      }
    default:
      return state;
  }
};
